import React from "react";
import estilo from "./styles/Separador.module.css";

function Separador({ titulo }) {
  return (
    <div className={estilo.separador}>
      <h2 className={estilo.titulo}>{titulo}</h2>
      <div className={estilo.mas}>
        <p>Ver más</p>
      </div>
    </div>
  );
}

export default Separador;
